import React, { useState, useCallback } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import DropdownToggle from 'reactstrap/lib/DropdownToggle';
import DropdownMenu from 'reactstrap/lib/DropdownMenu';
import Dropdown from 'reactstrap/lib/Dropdown';
import DropdownItem from 'reactstrap/lib/DropdownItem';
import { CONDITIONS_FOR_TABLE_DISPLAY } from 'site-modules/shared/constants/appraisal/appraisal';

import './appraisal-report-step-condition-dropdown.scss';

export function AppraisalReportConditionDropdown({ selectedCondition, onUpdate, conditionClassName = '' }) {
  const [isOpen, setIsOpen] = useState(false);

  const onChange = useCallback(
    ({ currentTarget: { value } }) => {
      onUpdate(value);
    },
    [onUpdate]
  );

  const onToggleOpen = useCallback(() => {
    setIsOpen(state => !state);
  }, []);

  return (
    <Dropdown isOpen={isOpen} toggle={onToggleOpen} className="condition-container align-baseline" setActiveFromChild>
      <DropdownToggle
        className="m-0 p-0 condition text-capitalize size-16"
        aria-label={`Your car's value ${selectedCondition}`}
      >
        <span data-testid="selected-vehicle-condition" className={classnames('px-0_25', conditionClassName)}>
          {selectedCondition}
        </span>
        <i aria-hidden className="brand-primary-darker size-12 py-0 my-0 pe-0_25 icon-arrow-down3" />
      </DropdownToggle>
      <DropdownMenu end className="condition-dropdown-shadow p-0_25">
        {CONDITIONS_FOR_TABLE_DISPLAY.map(({ title: condition, text }) => {
          const isSelected = condition === selectedCondition;
          const descriptionId = `${condition}-description`;

          return (
            <DropdownItem
              key={condition}
              className={classnames(
                'condition-dropdown-btn size-14  fw-normal text-gray-darker py-0_5 px-0_75 m-0 w-100',
                {
                  'fw-bold': isSelected,
                }
              )}
              onClick={onChange}
              data-value={condition}
              aria-checked={isSelected}
              aria-label={condition}
              aria-describedby={descriptionId}
              value={condition}
            >
              <span
                className="btn-title d-flex text-capitalize justify-content-between text-gray-darker"
                data-testid={`vehicle-condition-${condition}`}
              >
                {condition}
                <i
                  aria-hidden
                  hidden={!isSelected}
                  className="btn-title-icon text-primary-darker fw-bold align-self-center icon-checkmark me-0_25"
                />
              </span>
              <span id={descriptionId} className="display-6 condition-dropdown-description">
                {text}
              </span>
            </DropdownItem>
          );
        })}
      </DropdownMenu>
    </Dropdown>
  );
}

AppraisalReportConditionDropdown.propTypes = {
  selectedCondition: PropTypes.string.isRequired,
  onUpdate: PropTypes.func.isRequired,
  conditionClassName: PropTypes.string,
};
